// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-bonuses-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Montserrat', sans-serif;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

.header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.title {
  color: #2c3e50;
  font-size: 2.8rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #f09502, #ff6b35);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.subtitle {
  color: #5a6c7d;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.refresh-btn {
  background: linear-gradient(135deg, #f09502, #ff6b35);
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(240, 149, 2, 0.3);
}

.refresh-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(240, 149, 2, 0.4);
  background: linear-gradient(135deg, #e08500, #e55a2b);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #666;
}

.loading-container p {
  margin-top: 1rem;
  font-size: 1.1rem;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.bonus-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.bonus-section:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.section-title {
  color: #2c3e50;
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.section-title i {
  color: #f09502;
  font-size: 1.5rem;
}

.bonuses-table {
  width: 100%;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  border: 1px solid #e9ecef;
}

.table-header {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1.2fr 1.2fr 1.2fr 1.5fr;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-bottom: 2px solid #dee2e6;
  font-weight: 700;
  color: #2c3e50;
  font-size: 1rem;
}

.table-row {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1.2fr 1.2fr 1.2fr 1.5fr;
  border-bottom: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

/* Grid específico para solicitudes rechazadas (7 columnas) */
.bonus-section:has(.reason-cell) .table-header,
.bonus-section:has(.reason-cell) .table-row {
  grid-template-columns: 1.2fr 0.8fr 1fr 1fr 1fr 1.5fr 1.2fr;
}

.table-row:hover {
  background: linear-gradient(135deg, #f8f9fa, #f1f3f4);
  transform: scale(1.01);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.table-row:last-child {
  border-bottom: none;
}

.table-cell {
  padding: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #e9ecef;
  font-size: 1rem;
  text-align: center;
}

.table-cell:last-child {
  border-right: none;
}

.table-header .table-cell {
  padding: 1.2rem;
  font-weight: 700;
  color: #2c3e50;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  font-size: 1rem;
}

.bonuses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.bonus-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #f09502;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.bonus-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.bonus-card.pending {
  border-left-color: #ffc107;
}

.bonus-card.approved {
  border-left-color: #28a745;
}

.bonus-card.rejected {
  border-left-color: #dc3545;
  opacity: 0.8;
}

.bonus-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.bonus-info {
  flex: 1;
}

.bonus-title {
  color: #333;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.bonus-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-approved {
  background-color: #d4edda;
  color: #155724;
}

.status-rejected {
  background-color: #f8d7da;
  color: #721c24;
}

.status-default {
  background-color: #e2e3e5;
  color: #383d41;
}

.bonus-amount {
  text-align: right;
  min-width: 100px;
}

/* Estilos específicos para las celdas de la tabla */
.user-info {
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.user-email {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
  word-break: break-word;
  text-align: center;
}

.hubspot-id {
  justify-content: center;
}

.hubspot-badge {
  background: linear-gradient(135deg, #4a5568, #2d3748);
  color: white;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(45, 55, 72, 0.3);
}

.amount-cell {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
}

.project-cell {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
  text-align: center;
}



.date-cell {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
  text-align: center;
}

.reason-cell {
  font-size: 0.85rem;
  color: #dc3545;
  font-weight: 500;
  text-align: center;
  font-style: italic;
}

.actions-cell {
  justify-content: center;
}

.amount {
  display: block;
  font-size: 1.2rem;
  font-weight: 700;
  color: #f09502;
}

.percentage {
  display: block;
  font-size: 1.2rem;
  color: #28a745;
  font-weight: 600;
}

.bonus-details {
  margin-bottom: 1.5rem;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding: 0.5rem 0;
}

.detail-item:last-child {
  margin-bottom: 0;
}

.label {
  font-weight: 600;
  color: #666;
  font-size: 0.9rem;
}

.value {
  color: #333;
  font-size: 0.9rem;
  text-align: right;
  max-width: 60%;
  word-wrap: break-word;
}

.rejection-reason {
  color: #dc3545;
  font-style: italic;
}

.bonus-actions {
  display: flex;
  gap: 0.8rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.bonus-actions .btn {
  flex: 1;
  min-width: 100px;
  padding: 0.6rem 1rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.approve-btn {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
}

.approve-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4);
  background: linear-gradient(135deg, #218838, #1ea085);
}

.reject-btn {
  background: linear-gradient(135deg, #dc3545, #fd7e14);
  color: white;
}

.reject-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.4);
  background: linear-gradient(135deg, #c82333, #e55a2b);
}

.no-requests {
  text-align: center;
  padding: 3rem;
  color: #666;
}

.no-requests-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.no-requests-content i {
  font-size: 4rem;
  color: #ccc;
}

.no-requests-content h3 {
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.no-requests-content p {
  color: #666;
  font-size: 1.1rem;
  margin: 0;
}

@media (max-width: 768px) {
  .manage-bonuses-container {
    padding: 1rem;
  }

  .header {
    padding: 1.5rem;
  }

  .title {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .bonus-section {
    padding: 1.5rem;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .table-cell {
    padding: 0.8rem;
    border-right: none;
    border-bottom: 1px solid #e9ecef;
  }

  .table-header .table-cell {
    background: #f8f9fa;
    font-weight: 700;
    color: #2c3e50;
  }

  .bonuses-grid {
    grid-template-columns: 1fr;
  }

  .bonus-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .bonus-actions .btn {
    min-width: auto;
    width: 100%;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .value {
    text-align: left;
    max-width: 100%;
  }

  .hubspot-badge {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }
}

/* Estilos para el modal de SweetAlert2 */
:host ::ng-deep .swal2-popup {
  border-radius: 12px;
  max-height: 85vh !important;
  overflow-y: auto !important;
  padding: 1.5rem !important;
  min-width: 600px !important;
  max-width: 90vw !important;
  margin: 2vh auto !important;
}

:host ::ng-deep .swal2-title {
  color: #333;
  font-weight: 700;
  margin-bottom: 1rem !important;
  font-size: 1.4rem !important;
  padding: 0 !important;
}

:host ::ng-deep .swal2-container {
  padding: 1rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 100vh !important;
}

:host ::ng-deep .swal2-html-container {
  margin: 1rem 0 !important;
  max-height: 50vh !important;
  overflow-y: auto !important;
  text-align: left !important;
  padding: 0 !important;
}

:host ::ng-deep .swal2-actions {
  margin-top: 1.5rem !important;
  gap: 1rem !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

:host ::ng-deep .swal2-confirm {
  background: linear-gradient(135deg, #28a745, #20c997) !important;
  border: none !important;
  border-radius: 25px !important;
  padding: 0.75rem 1.5rem !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

:host ::ng-deep .swal2-confirm:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4) !important;
  background: linear-gradient(135deg, #218838, #1ea085) !important;
}

:host ::ng-deep .swal2-cancel {
  background: #6c757d !important;
  border: none !important;
  border-radius: 25px !important;
  padding: 0.75rem 1.5rem !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

:host ::ng-deep .swal2-cancel:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.4) !important;
  background: #5a6268 !important;
}

:host ::ng-deep .swal2-select {
  width: 50% !important;
  max-width: 250px !important;
  min-width: 200px !important;
  padding: 0.75rem !important;
  border: 2px solid #e9ecef !important;
  border-radius: 8px !important;
  font-size: 1rem !important;
  transition: all 0.3s ease !important;
  margin: 0 auto !important;
  display: block !important;
  box-sizing: border-box !important;
}

:host ::ng-deep .swal2-select:focus {
  border-color: #28a745 !important;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
  outline: none !important;
}

:host ::ng-deep .swal2-textarea {
  width: 100% !important;
  padding: 0.75rem !important;
  border: 2px solid #e9ecef !important;
  border-radius: 8px !important;
  font-size: 1rem !important;
  resize: vertical !important;
  min-height: 100px !important;
  transition: all 0.3s ease !important;
}

:host ::ng-deep .swal2-textarea:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
  outline: none !important;
}

/* Estilo más específico para el select */
:host ::ng-deep .swal2-popup select,
:host ::ng-deep .swal2-html-container select {
  width: 50% !important;
  max-width: 250px !important;
  min-width: 200px !important;
  margin: 0 auto !important;
  display: block !important;
}

/* Estilos para el contenido HTML del modal */
:host ::ng-deep .swal2-html-container p {
  margin: 0.5rem 0 !important;
  padding: 0 !important;
  line-height: 1.4 !important;
}

:host ::ng-deep .swal2-html-container label {
  margin: 1rem 0 0.5rem 0 !important;
  display: block !important;
  font-weight: 600 !important;
}

:host ::ng-deep .swal2-html-container div {
  margin: 0.5rem 0 !important;
}

/* Clases específicas para modales de bonificaciones */
:host ::ng-deep .bonus-modal-info {
  text-align: center;
  margin-bottom: 20px;
}

:host ::ng-deep .bonus-modal-label {
  font-weight: 600;
  display: block;
  margin-bottom: 10px;
}

:host ::ng-deep .bonus-modal-select {
  width: 50% !important;
  max-width: 250px !important;
  padding: 8px !important;
  border: 1px solid #ced4da !important;
  border-radius: 4px !important;
  margin: 1rem auto 0 auto !important;
  display: block !important;
}

:host ::ng-deep .bonus-modal-textarea {
  width: 100% !important;
  min-height: 100px !important;
  padding: 8px !important;
  border: 1px solid #ced4da !important;
  border-radius: 4px !important;
}

/* Header de la sección principal con controles */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.95);
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.section-title {
  color: #2c3e50;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.section-title i {
  color: #f09502;
  font-size: 1.6rem;
}

.section-controls {
  display: flex;
  gap: 0.75rem;
}

.section-controls .btn {
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  font-weight: 600;
  border: 2px solid #f09502;
  color: #f09502;
  background: transparent;
  transition: all 0.3s ease;
}

.section-controls .btn:hover {
  background: #f09502;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(240, 149, 2, 0.3);
}

/* Estilo específico para el botón de Excel */
.section-controls .btn-success {
  background: #28a745 !important;
  color: white !important;
  border-color: #28a745 !important;
}

.section-controls .btn-success:hover {
  background: #218838 !important;
  color: white !important;
  border-color: #1e7e34 !important;
}

/* Header de subsección clickeable */
.subsection-header {
  cursor: pointer;
  padding: 1rem;
  border-radius: 10px;
  transition: all 0.2s ease;
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.subsection-header:hover {
  background: rgba(255, 255, 255, 0.95);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.subsection-title {
  color: #2c3e50;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e9ecef;
  transition: all 0.2s ease;
}

.subsection-title i {
  color: #f09502;
  transition: transform 0.2s ease;
  font-size: 1.3rem;
}

.subsection-title i.bi-clock-fill {
  color: #ffc107;
}

.subsection-title i.bi-check-circle-fill {
  color: #28a745;
}

.subsection-title i.bi-x-circle-fill {
  color: #dc3545;
}

/* Icono de chevron para fold/unfold */
.subsection-title i.bi-chevron-up,
.subsection-title i.bi-chevron-down {
  margin-left: auto;
  color: #6c757d;
  font-size: 1.2rem;
  transition: transform 0.2s ease;
}

.subsection-header:hover .subsection-title i.bi-chevron-up,
.subsection-header:hover .subsection-title i.bi-chevron-down {
  color: #f09502;
}

/* Animación para el contenido colapsado */
.bonuses-table {
  transition: all 0.3s ease;
  overflow: hidden;
}

.bonuses-table.collapsed {
  max-height: 0;
  opacity: 0;
  margin: 0;
  padding: 0;
}

/* Estilos para el estado colapsado del header */
.subsection-header.collapsed .subsection-title {
  border-bottom: none;
  padding-bottom: 0;
}

.subsection-header.collapsed .subsection-title i.bi-chevron-down {
  transform: rotate(0deg);
}

.subsection-header:not(.collapsed) .subsection-title i.bi-chevron-up {
  transform: rotate(0deg);
}

/* Responsive design */
@media (max-width: 768px) {
  .manage-bonuses-container {
    padding: 1rem;
  }

  .title {
    font-size: 1.5rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .content {
    padding: 1rem;
  }

  /* Responsive para el header de sección */
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .section-controls {
    width: 100%;
    justify-content: center;
  }

  .section-controls .btn {
    flex: 1;
    max-width: 150px;
  }

  /* Responsive para headers de subsección */
  .subsection-header {
    padding: 0.75rem;
  }

  .subsection-title {
    font-size: 1rem;
    flex-wrap: wrap;
  }

  .subsection-title i.bi-chevron-up,
  .subsection-title i.bi-chevron-down {
    font-size: 1rem;
  }

  /* Responsive para la tabla */
  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .table-cell {
    border-right: none;
    border-bottom: 1px solid #e9ecef;
    padding: 0.5rem;
  }

  .table-header .table-cell {
    background-color: #f8f9fa;
    font-weight: 600;
    border-bottom: 2px solid #dee2e6;
  }
}

@media (max-width: 480px) {
  .manage-bonuses-container {
    padding: 0.5rem;
  }

  .content {
    padding: 0.5rem;
  }

  .section-title {
    font-size: 1.25rem;
  }

  .subsection-title {
    font-size: 0.9rem;
  }
}

/* Estilos para la columna combinada de bonificación */
.bonus-cell {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  padding: 0.75rem 0.5rem;
}

.bonus-amount {
  color: #f09502;
  font-weight: 700;
  font-size: 1.1rem;
  line-height: 1.2;
}

.bonus-percentage {
  color: #28a745;
  font-weight: 700;
  font-size: 1.1rem;
  line-height: 1.2;
}

.no-bonus {
  color: #6c757d;
  font-style: italic;
  font-size: 1rem;
}

/* Estilos para bonificaciones aprobadas */
.bonus-amount.approved {
  color: #28a745;
  font-weight: 700;
  font-size: 1.1rem;
}

.bonus-percentage.approved {
  color: #28a745;
  font-weight: 700;
  font-size: 1.1rem;
}

/* Estilos para bonificaciones rechazadas */
.bonus-amount.rejected {
  color: #dc3545;
  font-weight: 700;
  font-size: 1.1rem;
  text-decoration: line-through;
}

.bonus-percentage.rejected {
  color: #dc3545;
  font-weight: 700;
  font-size: 1.1rem;
  text-decoration: line-through;
}

/* Estilos para badges de tipo de aprobación */
.approval-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.approval-amount {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.approval-percentage {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.approval-both {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.approval-unknown {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/manage-bonuses/manage-bonuses.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,2BAA2B;EAC3B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,qDAAqD;EACrD,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;;EAEE,0DAA0D;AAC5D;;AAEA;EACE,qDAAqD;EACrD,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;;;AAIA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,gEAAgE;EAChE,uBAAuB;EACvB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;EACxD,gEAAgE;AAClE;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,0DAA0D;EAC1D,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA,yCAAyC;AACzC;;EAEE,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,6CAA6C;AAC7C;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;;EAEE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;;IAEE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".manage-bonuses-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 2rem;\n  font-family: 'Montserrat', sans-serif;\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  min-height: 100vh;\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 15px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.title {\n  color: #2c3e50;\n  font-size: 2.8rem;\n  font-weight: 800;\n  margin-bottom: 0.5rem;\n  background: linear-gradient(135deg, #f09502, #ff6b35);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.subtitle {\n  color: #5a6c7d;\n  font-size: 1.2rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.refresh-btn {\n  background: linear-gradient(135deg, #f09502, #ff6b35);\n  border: none;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 25px;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(240, 149, 2, 0.3);\n}\n\n.refresh-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(240, 149, 2, 0.4);\n  background: linear-gradient(135deg, #e08500, #e55a2b);\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: #666;\n}\n\n.loading-container p {\n  margin-top: 1rem;\n  font-size: 1.1rem;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.bonus-section {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 20px;\n  padding: 2rem;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.bonus-section:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.section-title {\n  color: #2c3e50;\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.section-title i {\n  color: #f09502;\n  font-size: 1.5rem;\n}\n\n.bonuses-table {\n  width: 100%;\n  background: white;\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  margin-top: 1rem;\n  border: 1px solid #e9ecef;\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr 1.2fr 1.2fr 1.2fr 1.5fr;\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n  border-bottom: 2px solid #dee2e6;\n  font-weight: 700;\n  color: #2c3e50;\n  font-size: 1rem;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr 1.2fr 1.2fr 1.2fr 1.5fr;\n  border-bottom: 1px solid #e9ecef;\n  transition: all 0.3s ease;\n}\n\n/* Grid específico para solicitudes rechazadas (7 columnas) */\n.bonus-section:has(.reason-cell) .table-header,\n.bonus-section:has(.reason-cell) .table-row {\n  grid-template-columns: 1.2fr 0.8fr 1fr 1fr 1fr 1.5fr 1.2fr;\n}\n\n.table-row:hover {\n  background: linear-gradient(135deg, #f8f9fa, #f1f3f4);\n  transform: scale(1.01);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.table-row:last-child {\n  border-bottom: none;\n}\n\n.table-cell {\n  padding: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-right: 1px solid #e9ecef;\n  font-size: 1rem;\n  text-align: center;\n}\n\n.table-cell:last-child {\n  border-right: none;\n}\n\n.table-header .table-cell {\n  padding: 1.2rem;\n  font-weight: 700;\n  color: #2c3e50;\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n  font-size: 1rem;\n}\n\n.bonuses-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n.bonus-card {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-left: 4px solid #f09502;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.bonus-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.bonus-card.pending {\n  border-left-color: #ffc107;\n}\n\n.bonus-card.approved {\n  border-left-color: #28a745;\n}\n\n.bonus-card.rejected {\n  border-left-color: #dc3545;\n  opacity: 0.8;\n}\n\n.bonus-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.bonus-info {\n  flex: 1;\n}\n\n.bonus-title {\n  color: #333;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n}\n\n.bonus-status {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.status-pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-approved {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.status-default {\n  background-color: #e2e3e5;\n  color: #383d41;\n}\n\n.bonus-amount {\n  text-align: right;\n  min-width: 100px;\n}\n\n/* Estilos específicos para las celdas de la tabla */\n.user-info {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.user-email {\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 1rem;\n  word-break: break-word;\n  text-align: center;\n}\n\n.hubspot-id {\n  justify-content: center;\n}\n\n.hubspot-badge {\n  background: linear-gradient(135deg, #4a5568, #2d3748);\n  color: white;\n  padding: 0.4rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(45, 55, 72, 0.3);\n}\n\n.amount-cell {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n}\n\n.project-cell {\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 1rem;\n  text-align: center;\n}\n\n\n\n.date-cell {\n  font-size: 0.9rem;\n  color: #6c757d;\n  font-weight: 500;\n  text-align: center;\n}\n\n.reason-cell {\n  font-size: 0.85rem;\n  color: #dc3545;\n  font-weight: 500;\n  text-align: center;\n  font-style: italic;\n}\n\n.actions-cell {\n  justify-content: center;\n}\n\n.amount {\n  display: block;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #f09502;\n}\n\n.percentage {\n  display: block;\n  font-size: 1.2rem;\n  color: #28a745;\n  font-weight: 600;\n}\n\n.bonus-details {\n  margin-bottom: 1.5rem;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  padding: 0.5rem 0;\n}\n\n.detail-item:last-child {\n  margin-bottom: 0;\n}\n\n.label {\n  font-weight: 600;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.value {\n  color: #333;\n  font-size: 0.9rem;\n  text-align: right;\n  max-width: 60%;\n  word-wrap: break-word;\n}\n\n.rejection-reason {\n  color: #dc3545;\n  font-style: italic;\n}\n\n.bonus-actions {\n  display: flex;\n  gap: 0.8rem;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.bonus-actions .btn {\n  flex: 1;\n  min-width: 100px;\n  padding: 0.6rem 1rem;\n  border-radius: 25px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.approve-btn {\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n}\n\n.approve-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4);\n  background: linear-gradient(135deg, #218838, #1ea085);\n}\n\n.reject-btn {\n  background: linear-gradient(135deg, #dc3545, #fd7e14);\n  color: white;\n}\n\n.reject-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.4);\n  background: linear-gradient(135deg, #c82333, #e55a2b);\n}\n\n.no-requests {\n  text-align: center;\n  padding: 3rem;\n  color: #666;\n}\n\n.no-requests-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.no-requests-content i {\n  font-size: 4rem;\n  color: #ccc;\n}\n\n.no-requests-content h3 {\n  color: #333;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.no-requests-content p {\n  color: #666;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .manage-bonuses-container {\n    padding: 1rem;\n  }\n\n  .header {\n    padding: 1.5rem;\n  }\n\n  .title {\n    font-size: 2rem;\n  }\n\n  .subtitle {\n    font-size: 1rem;\n  }\n\n  .bonus-section {\n    padding: 1.5rem;\n  }\n\n  .section-title {\n    font-size: 1.5rem;\n  }\n\n  .table-header,\n  .table-row {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .table-cell {\n    padding: 0.8rem;\n    border-right: none;\n    border-bottom: 1px solid #e9ecef;\n  }\n\n  .table-header .table-cell {\n    background: #f8f9fa;\n    font-weight: 700;\n    color: #2c3e50;\n  }\n\n  .bonuses-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .bonus-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .bonus-actions .btn {\n    min-width: auto;\n    width: 100%;\n  }\n\n  .detail-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n  }\n\n  .value {\n    text-align: left;\n    max-width: 100%;\n  }\n\n  .hubspot-badge {\n    font-size: 0.8rem;\n    padding: 0.3rem 0.6rem;\n  }\n}\n\n/* Estilos para el modal de SweetAlert2 */\n:host ::ng-deep .swal2-popup {\n  border-radius: 12px;\n  max-height: 85vh !important;\n  overflow-y: auto !important;\n  padding: 1.5rem !important;\n  min-width: 600px !important;\n  max-width: 90vw !important;\n  margin: 2vh auto !important;\n}\n\n:host ::ng-deep .swal2-title {\n  color: #333;\n  font-weight: 700;\n  margin-bottom: 1rem !important;\n  font-size: 1.4rem !important;\n  padding: 0 !important;\n}\n\n:host ::ng-deep .swal2-container {\n  padding: 1rem !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  min-height: 100vh !important;\n}\n\n:host ::ng-deep .swal2-html-container {\n  margin: 1rem 0 !important;\n  max-height: 50vh !important;\n  overflow-y: auto !important;\n  text-align: left !important;\n  padding: 0 !important;\n}\n\n:host ::ng-deep .swal2-actions {\n  margin-top: 1.5rem !important;\n  gap: 1rem !important;\n  padding: 0 !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n:host ::ng-deep .swal2-confirm {\n  background: linear-gradient(135deg, #28a745, #20c997) !important;\n  border: none !important;\n  border-radius: 25px !important;\n  padding: 0.75rem 1.5rem !important;\n  font-weight: 600 !important;\n  transition: all 0.3s ease !important;\n}\n\n:host ::ng-deep .swal2-confirm:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4) !important;\n  background: linear-gradient(135deg, #218838, #1ea085) !important;\n}\n\n:host ::ng-deep .swal2-cancel {\n  background: #6c757d !important;\n  border: none !important;\n  border-radius: 25px !important;\n  padding: 0.75rem 1.5rem !important;\n  font-weight: 600 !important;\n  transition: all 0.3s ease !important;\n}\n\n:host ::ng-deep .swal2-cancel:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.4) !important;\n  background: #5a6268 !important;\n}\n\n:host ::ng-deep .swal2-select {\n  width: 50% !important;\n  max-width: 250px !important;\n  min-width: 200px !important;\n  padding: 0.75rem !important;\n  border: 2px solid #e9ecef !important;\n  border-radius: 8px !important;\n  font-size: 1rem !important;\n  transition: all 0.3s ease !important;\n  margin: 0 auto !important;\n  display: block !important;\n  box-sizing: border-box !important;\n}\n\n:host ::ng-deep .swal2-select:focus {\n  border-color: #28a745 !important;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;\n  outline: none !important;\n}\n\n:host ::ng-deep .swal2-textarea {\n  width: 100% !important;\n  padding: 0.75rem !important;\n  border: 2px solid #e9ecef !important;\n  border-radius: 8px !important;\n  font-size: 1rem !important;\n  resize: vertical !important;\n  min-height: 100px !important;\n  transition: all 0.3s ease !important;\n}\n\n:host ::ng-deep .swal2-textarea:focus {\n  border-color: #dc3545 !important;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;\n  outline: none !important;\n}\n\n/* Estilo más específico para el select */\n:host ::ng-deep .swal2-popup select,\n:host ::ng-deep .swal2-html-container select {\n  width: 50% !important;\n  max-width: 250px !important;\n  min-width: 200px !important;\n  margin: 0 auto !important;\n  display: block !important;\n}\n\n/* Estilos para el contenido HTML del modal */\n:host ::ng-deep .swal2-html-container p {\n  margin: 0.5rem 0 !important;\n  padding: 0 !important;\n  line-height: 1.4 !important;\n}\n\n:host ::ng-deep .swal2-html-container label {\n  margin: 1rem 0 0.5rem 0 !important;\n  display: block !important;\n  font-weight: 600 !important;\n}\n\n:host ::ng-deep .swal2-html-container div {\n  margin: 0.5rem 0 !important;\n}\n\n/* Clases específicas para modales de bonificaciones */\n:host ::ng-deep .bonus-modal-info {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n:host ::ng-deep .bonus-modal-label {\n  font-weight: 600;\n  display: block;\n  margin-bottom: 10px;\n}\n\n:host ::ng-deep .bonus-modal-select {\n  width: 50% !important;\n  max-width: 250px !important;\n  padding: 8px !important;\n  border: 1px solid #ced4da !important;\n  border-radius: 4px !important;\n  margin: 1rem auto 0 auto !important;\n  display: block !important;\n}\n\n:host ::ng-deep .bonus-modal-textarea {\n  width: 100% !important;\n  min-height: 100px !important;\n  padding: 8px !important;\n  border: 1px solid #ced4da !important;\n  border-radius: 4px !important;\n}\n\n/* Header de la sección principal con controles */\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n  background: rgba(255, 255, 255, 0.95);\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.section-title {\n  color: #2c3e50;\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.section-title i {\n  color: #f09502;\n  font-size: 1.6rem;\n}\n\n.section-controls {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.section-controls .btn {\n  font-size: 0.9rem;\n  padding: 0.5rem 1rem;\n  font-weight: 600;\n  border: 2px solid #f09502;\n  color: #f09502;\n  background: transparent;\n  transition: all 0.3s ease;\n}\n\n.section-controls .btn:hover {\n  background: #f09502;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(240, 149, 2, 0.3);\n}\n\n/* Estilo específico para el botón de Excel */\n.section-controls .btn-success {\n  background: #28a745 !important;\n  color: white !important;\n  border-color: #28a745 !important;\n}\n\n.section-controls .btn-success:hover {\n  background: #218838 !important;\n  color: white !important;\n  border-color: #1e7e34 !important;\n}\n\n/* Header de subsección clickeable */\n.subsection-header {\n  cursor: pointer;\n  padding: 1rem;\n  border-radius: 10px;\n  transition: all 0.2s ease;\n  margin-bottom: 1rem;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.subsection-header:hover {\n  background: rgba(255, 255, 255, 0.95);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n.subsection-title {\n  color: #2c3e50;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid #e9ecef;\n  transition: all 0.2s ease;\n}\n\n.subsection-title i {\n  color: #f09502;\n  transition: transform 0.2s ease;\n  font-size: 1.3rem;\n}\n\n.subsection-title i.bi-clock-fill {\n  color: #ffc107;\n}\n\n.subsection-title i.bi-check-circle-fill {\n  color: #28a745;\n}\n\n.subsection-title i.bi-x-circle-fill {\n  color: #dc3545;\n}\n\n/* Icono de chevron para fold/unfold */\n.subsection-title i.bi-chevron-up,\n.subsection-title i.bi-chevron-down {\n  margin-left: auto;\n  color: #6c757d;\n  font-size: 1.2rem;\n  transition: transform 0.2s ease;\n}\n\n.subsection-header:hover .subsection-title i.bi-chevron-up,\n.subsection-header:hover .subsection-title i.bi-chevron-down {\n  color: #f09502;\n}\n\n/* Animación para el contenido colapsado */\n.bonuses-table {\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.bonuses-table.collapsed {\n  max-height: 0;\n  opacity: 0;\n  margin: 0;\n  padding: 0;\n}\n\n/* Estilos para el estado colapsado del header */\n.subsection-header.collapsed .subsection-title {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.subsection-header.collapsed .subsection-title i.bi-chevron-down {\n  transform: rotate(0deg);\n}\n\n.subsection-header:not(.collapsed) .subsection-title i.bi-chevron-up {\n  transform: rotate(0deg);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .manage-bonuses-container {\n    padding: 1rem;\n  }\n\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .subtitle {\n    font-size: 1rem;\n  }\n\n  .content {\n    padding: 1rem;\n  }\n\n  /* Responsive para el header de sección */\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .section-controls {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .section-controls .btn {\n    flex: 1;\n    max-width: 150px;\n  }\n\n  /* Responsive para headers de subsección */\n  .subsection-header {\n    padding: 0.75rem;\n  }\n\n  .subsection-title {\n    font-size: 1rem;\n    flex-wrap: wrap;\n  }\n\n  .subsection-title i.bi-chevron-up,\n  .subsection-title i.bi-chevron-down {\n    font-size: 1rem;\n  }\n\n  /* Responsive para la tabla */\n  .table-header,\n  .table-row {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .table-cell {\n    border-right: none;\n    border-bottom: 1px solid #e9ecef;\n    padding: 0.5rem;\n  }\n\n  .table-header .table-cell {\n    background-color: #f8f9fa;\n    font-weight: 600;\n    border-bottom: 2px solid #dee2e6;\n  }\n}\n\n@media (max-width: 480px) {\n  .manage-bonuses-container {\n    padding: 0.5rem;\n  }\n\n  .content {\n    padding: 0.5rem;\n  }\n\n  .section-title {\n    font-size: 1.25rem;\n  }\n\n  .subsection-title {\n    font-size: 0.9rem;\n  }\n}\n\n/* Estilos para la columna combinada de bonificación */\n.bonus-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n  padding: 0.75rem 0.5rem;\n}\n\n.bonus-amount {\n  color: #f09502;\n  font-weight: 700;\n  font-size: 1.1rem;\n  line-height: 1.2;\n}\n\n.bonus-percentage {\n  color: #28a745;\n  font-weight: 700;\n  font-size: 1.1rem;\n  line-height: 1.2;\n}\n\n.no-bonus {\n  color: #6c757d;\n  font-style: italic;\n  font-size: 1rem;\n}\n\n/* Estilos para bonificaciones aprobadas */\n.bonus-amount.approved {\n  color: #28a745;\n  font-weight: 700;\n  font-size: 1.1rem;\n}\n\n.bonus-percentage.approved {\n  color: #28a745;\n  font-weight: 700;\n  font-size: 1.1rem;\n}\n\n/* Estilos para bonificaciones rechazadas */\n.bonus-amount.rejected {\n  color: #dc3545;\n  font-weight: 700;\n  font-size: 1.1rem;\n  text-decoration: line-through;\n}\n\n.bonus-percentage.rejected {\n  color: #dc3545;\n  font-weight: 700;\n  font-size: 1.1rem;\n  text-decoration: line-through;\n}\n\n/* Estilos para badges de tipo de aprobación */\n.approval-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.approval-amount {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.approval-percentage {\n  background-color: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n}\n\n.approval-both {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.approval-unknown {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
